import React, { useState } from 'react'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import TileSelectList from 'components/TileSelectList'
import { SportsbookCheckbox } from 'components/ui'

import Baccarat from 'icons/Baccarat'
import Blackjack from 'icons/Blackjack'
import Craps from 'icons/Craps'
import Poker from 'icons/Poker'
import Roulette from 'icons/Roulette'
import Slots from 'icons/Slots'
import VideoPoker from 'icons/VideoPoker'

import FormsStore from 'stores/forms'
import { useStore } from 'hooks'

const CasinoGamesSchema = Yup.object().shape({
  casino_games: Yup.array().of(Yup.string().min(1, 'Field is required').required('Field is required'))
})

const casinoGamesOptions = [
  {
    value: 'poker',
    label: 'Poker',
    icon: Poker
  },
  {
    value: 'blackjack',
    label: 'Blackjack',
    icon: Blackjack
  },
  {
    value: 'roulette',
    label: 'Roulette',
    icon: Roulette
  },
  {
    value: 'craps',
    label: 'Craps',
    icon: Craps
  },
  {
    value: 'baccarat',
    label: 'Baccarat',
    icon: Baccarat
  },
  {
    value: 'video poker',
    label: 'Video Poker',
    icon: VideoPoker
  },
  {
    value: 'slots',
    label: 'Slots',
    icon: Slots
  }
]

const CasinoGamesForm = () => {
  const [doesntPlay, setDoesntPlay] = useState(false)
  const [initalTileData, setInitialTileData] = useState([])
  const router = useRouter()
  const formsStore = useStore(FormsStore)

  const handleSubmit = ({ casino_games }) => {
    // add info to the forms store
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'Do you play casino games?',
      answer: casino_games
    })

    router.push('/barstool-sportsbook/horses')
  }

  return (
    <Formik
      initialValues={{
        casino_games: []
      }}
      validationSchema={CasinoGamesSchema}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, values }) => (
        <>
          <Form className='sportsBookForm'>
            <p>Yes, I play:</p>
            <Field name='casino_games'>
              {({ field, form }) => (
                <TileSelectList
                  {...field}
                  {...form}
                  resetSelectedValuesTo={initalTileData}
                  options={casinoGamesOptions}
                  onChange={(games) => {
                    // uncheck the doesnt play checkbox if it is checked
                    if (doesntPlay && games.length) setDoesntPlay(false)

                    // set the casino_games field to the new games data
                    setFieldValue(field.name, games)
                  }}
                  allowOtherOption
                />
              )}
            </Field>
            <ErrorMessage name='casino_games' component='div' className='field__error' />
            <br />
            <div className='checkbox-and-cta'>
              <SportsbookCheckbox
                label="I don't gamble on casino games"
                checked={doesntPlay}
                readOnly
                onClick={() => {
                  // reset the initial data for the tiles if checkbox is being turned on
                  if (!doesntPlay) setInitialTileData([])

                  // toggle the value
                  setDoesntPlay(!doesntPlay)
                }}
              />
              <br />
              <button
                disabled={!values.casino_games.length && !doesntPlay}
                type='submit'
                className={`sportsBook__submitButton${!values.casino_games.length && !doesntPlay ? '--disabled' : ''}`}
              >
                Continue
              </button>
            </div>
          </Form>
          <style jsx>{`
            p {
              color: #010101;
              font-family: 'IBM Plex Sans Condensed';
              letter-spacing: 0;
              text-align: left;
              margin: 0 0 6px 4px;
              font-size: 16px;
            }
            .checkbox-and-cta {
              padding-left: 4px;
            }
          `}</style>
        </>
      )}
    </Formik>
  )
}

export default CasinoGamesForm
